import {SidebarPackages as PackagesComponent} from '@github-ui/code-view-sidebar/components/SidebarPackages'
import type {SidebarPackagesResponse} from '@github-ui/code-view-sidebar/types'
import {useSuspenseQuery} from '@github-ui/react-query'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

interface Props {
  ownerLogin: string
  repoName: string
}

export function SidebarPackages({ownerLogin, repoName}: Props) {
  const {data} = useSuspenseQuery({
    queryKey: ['code-view-sidebar', 'packages', {ownerLogin, repoName}],
    queryFn: async () => {
      const r = await verifiedFetchJSON(`/${ownerLogin}/${repoName}/_sidebar/packages`)
      return (await r.json()) as SidebarPackagesResponse
    },
  })

  if (!data) return null
  return <PackagesComponent {...data} />
}
